var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendMoneyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5248 0.952761C12.1598 0.730886 12.7698 1.34089 12.5479 1.97589L8.84476 12.5571C8.60413 13.2434 7.64788 13.2821 7.35288 12.6178L5.56601 8.59776L8.08101 6.08214C8.16381 5.99328 8.20888 5.87575 8.20674 5.75431C8.2046 5.63287 8.1554 5.51701 8.06952 5.43112C7.98364 5.34524 7.86777 5.29604 7.74633 5.2939C7.6249 5.29176 7.50737 5.33684 7.41851 5.41964L4.90288 7.93464L0.882882 6.14776C0.218507 5.85214 0.257882 4.89651 0.943507 4.65589L11.5248 0.952761Z",
    fill: "#F6F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMoneyIcon);
export default __webpack_public_path__ + "static/media/sendMoneyIcon.bf400c1d12a3fa7eb3ea55c2b45585fe.svg";
export { ForwardRef as ReactComponent };